(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	$('[data-focus-onclick]').each(function () {
		var el = $(this);
		var target = $(el.data('focus-onclick'));

		el.on('click', function (e) {
			e.preventDefault();

			target.focus();
		});
	});
})();
